var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompliance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.5334 13.042H16.4667C14.4084 13.042 12.7417 14.717 12.7417 16.767V24.6087C12.7417 26.6587 14.4167 28.3337 16.4667 28.3337H23.525C25.5834 28.3337 27.25 26.6587 27.25 24.6087V16.767C27.2584 14.7087 25.5834 13.042 23.5334 13.042Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9585 11.667H18.0418C17.1751 11.667 16.4668 12.367 16.4668 13.2337V14.017C16.4668 14.8837 17.1668 15.5837 18.0335 15.5837H21.9585C22.8251 15.5837 23.5251 14.8837 23.5251 14.017V13.2337C23.5335 12.367 22.8251 11.667 21.9585 11.667Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0082 24.1252C18.8498 24.1252 18.6915 24.0669 18.5665 23.9419L17.3165 22.6919C17.0748 22.4502 17.0748 22.0502 17.3165 21.8085C17.5582 21.5669 17.9582 21.5669 18.1998 21.8085L19.0082 22.6169L21.8998 19.7252C22.1415 19.4835 22.5415 19.4835 22.7832 19.7252C23.0248 19.9669 23.0248 20.3669 22.7832 20.6085L19.4498 23.9419C19.3332 24.0669 19.1665 24.1252 19.0082 24.1252Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/Compliance.3580323b.svg";
export { ForwardRef as ReactComponent };